{
  "filters": "Filtros",
  "columns": "Columnas",
  "chart": "Gráfico",
  "addFilter": "Añadir filtro",
  "addColumn": "Añadir columna",
  "field": "Campo",
  "comparison": "Comparación",
  "value": "Valor",
  "link": "Enlace",
  "savedReport": "Informe guardado correctamente",
  "downloadCsv": "Descargar como CSV",
  "dailyStats": "Estadísticas diarias",
  "subTradeRequest": "Solicitud de subcontratación",
  "client": "Cliente",
  "account": "Cuenta",
  "subAccount": "Subcuenta",
  "transfer": "Transferencia",
  "transaction": "Libro mayor",
  "trade": "Transacción",
  "clientGroup": "Grupo de clientes",
  "goal": "Meta",
  "day": "Día",
  "week": "Semana",
  "month": "Mes",
  "year": "Año",
  "newReport": "Nuevo reporte",
  "editReport": "Editar reporte",
  "download": "Descargar",
  "accessTypes": {
    "ORGANIZATIONAL": "Organizacional",
    "PUBLIC": "Público",
    "PRIVATE": "Privado"
  },
  "saveAs": {
    "modalButton": "Guardar como",
    "title": "Guardar como nuevo reporte",
    "name": "Nombre",
    "accessType": "Tipo de acceso",
    "button": "Guardar como"
  },
  "table": {
    "name": "Nombre",
    "type": "Tipo",
    "accessType": "Tipo de acceso",
    "author": "Autor",
    "organization": "Organización"
  },
  "column": {
    "id": "ID",
    "targetAmountCents": "Importe objetivo en céntimos",
    "organizationName": "Organización",
    "userId": "ID de usuario",
    "householdId": "ID del hogar",
    "primaryUserId": "ID de usuario principal",
    "type": "Tipo",
    "source": "Fuente",
    "name": "Nombre",
    "subAccountType": "Tipo de subcuenta",
    "subAccountSource": "Fuente de la subcuenta",
    "subAccountName": "Nombre de subcuenta",
    "amount": "Importe",
    "amountCents": "Importe (centavos)",
    "failReason": "Motivo del fallo",
    "withdrawalReason": "Motivo de la retirada",
    "withdrawalReasonDescription": "Descripción del motivo de la retirada",
    "adjustmentReason": "Motivo del ajuste",
    "isWithdrawAll": "Es retirar todo",
    "isAdjustment": "Es ajuste",
    "instantInvest": "Inversión instantánea",
    "description": "Descripción",
    "financialProductName": "Nombre del producto financiero",
    "financialProductId": "ID del producto financiero",
    "financialProductTicker": "Ticker del producto financiero",
    "accountId": "ID de cuenta",
    "accountType": "Tipo de cuenta",
    "accountState": "Estado de la cuenta",
    "accountCustodianAccountNumber": "Número de custodio de la cuenta",
    "accountCreatedAt": "Cuenta creada en",
    "accountUpdatedAt": "Cuenta actualizada el",
    "signedAllFormsAt": "Todos los formularios firmados en",
    "approvedAt": "Aprobado en",
    "subAccountSignedAllFormsAt": "La subcuenta firmada para todos los formularios en",
    "subAccountApprovedAt": "Subcuenta aprobada en",
    "subAccountCreatedAt": "Subcuenta creada el",
    "subAccountUpdatedAt": "Subcuenta actualizada el",
    "reconciledAt": "Reconciliado en",
    "effectiveDate": "Fecha de entrada en vigor",
    "subAccountId": "ID de subcuenta",
    "subAccountState": "Estado de subcuenta",
    "subAccountFinancialProductId": "ID de la cartera modelo de la subcuenta",
    "subAccountCompletedAt": "Subcuenta completada a las",
    "userLink": "Enlace del cliente",
    "householdLink": "Enlace doméstico",
    "primaryUserLink": "Enlace de usuario principal",
    "search": "Buscar",
    "accountTypes": "Tipos de cuentas",
    "firstName": "Nombre",
    "middleName": "Segundo nombre",
    "lastName": "Apellido",
    "state": "Estado",
    "primaryEmail": "Correo electrónico",
    "phone": "Teléfono",
    "streetAddress": "Dirección postal",
    "province": "Provincia",
    "city": "Ciudad",
    "dateOfBirth": "Fecha de nacimiento",
    "foreignTaxCountry": "País con impuestos extranjeros",
    "citizenships": "Ciudadanías",
    "companyType": "Tipo de empresa",
    "jobTitle": "Puesto",
    "studentAreaOfStudy": "Área de estudio",
    "investmentKnowledge": "Conocimientos sobre inversiones",
    "employmentStatus": "Situación laboral",
    "complianceState": "Estado de cumplimiento",
    "complianceIssueSource": "Origen del problema de cumplimiento",
    "iDCheckCompleted": "Verificación de identidad completada",
    "lastSuitabilityReviewAt": "Última revisión de idoneidad en",
    "suitabilityScore": "Puntuación de idoneidad",
    "language": "Idioma",
    "timezone": "Zona horaria",
    "maritalStatus": "Estado civil",
    "riskQuestion1": "Primera pregunta sobre riesgos",
    "riskQuestion2": "Segunda pregunta sobre riesgos",
    "createdAt": "Creado en",
    "updatedAt": "Actualizado el",
    "completedAt": "Completado en",
    "marketValueCents": "Valor de mercado",
    "annualIncomeCents": "Ingresos anuales (centavos)",
    "financialFixedAssetsCents": "Activos fijos (centavos)",
    "financialLiquidAssetsCents": "Activos líquidos (centavos)",
    "totalDebtCents": "Deuda total (centavos)",
    "totalNetWorthCents": "Patrimonio neto total (centavos)",
    "moneyAvailableCents": "Efectivo disponible (centavos)",
    "netContributionCents": "Contribuciones netas (centavos)",
    "newContributionCents": "Nuevas contribuciones (centavos)",
    "pendingContributionCents": "Contribuciones pendientes (centavos)",
    "cashOnHoldToTradeCents": "Efectivo en espera para negociar (centavos)",
    "cashOnHoldToWithdrawCents": "Efectivo en espera para retirar (centavos)",
    "marketValue": "Valor de mercado",
    "annualIncome": "Ingresos anuales",
    "financialFixedAssets": "Activos fijos",
    "financialLiquidAssets": "Activos líquidos",
    "totalDebt": "Deuda total",
    "totalNetWorth": "Patrimonio neto total",
    "moneyAvailable": "Efectivo disponible",
    "netContribution": "Contribuciones netas",
    "pendingContribution": "Contribuciones pendientes",
    "cashOnHoldToTrade": "Efectivo en espera para negociar",
    "cashOnHoldToWithdraw": "Efectivo en espera para retirar",
    "newContribution": "Nuevas contribuciones",
    "custodianAccountNumber": "Cuenta de custodio #",
    "primaryUserFirstName": "Nombre del usuario principal",
    "primaryUserMiddleName": "Segundo nombre del usuario principal",
    "primaryUserLastName": "Apellido del usuario principal",
    "primaryUserState": "Estado del usuario principal",
    "primaryUserPrimaryEmail": "Correo electrónico del usuario principal",
    "primaryUserPhone": "Teléfono del usuario principal",
    "primaryUserStreetAddress": "Dirección postal del usuario principal",
    "primaryUserProvince": "Provincia del usuario principal",
    "primaryUserCity": "Ciudad del usuario principal",
    "primaryUserDateOfBirth": "Fecha de nacimiento del usuario principal",
    "primaryUserCompanyType": "Tipo de empresa del usuario principal",
    "primaryUserJobTitle": "Cargo del usuario principal",
    "primaryUserStudentAreaOfStudy": "Área de estudio del usuario principal",
    "primaryUserInvestmentKnowledge": "Conocimientos básicos sobre inversiones para usuario principal",
    "primaryUserEmploymentStatus": "Situación laboral del usuario principal",
    "primaryUserComplianceState": "Estado de cumplimiento del usuario principal",
    "primaryUserSuitabilityScore": "Puntuación de idoneidad del usuario principal",
    "primaryUserLanguage": "Lengua del usuario principal",
    "primaryUserTimezone": "Zona horaria del usuario principal",
    "primaryUserMaritalStatus": "Estado civil del usuario principal",
    "primaryUserRiskQuestion1": "Pregunta inicial sobre riesgos del usuario principal",
    "primaryUserRiskQuestion2": "Pregunta de riesgo secundario del usuario principal",
    "primaryUserComplianceIssueSource": "Fuente del problema de cumplimiento del usuario principal",
    "primaryUserIDCheckCompleted": "Verificación de ID de usuario principal completada",
    "primaryUserLastSuitabilityReviewAt": "Última revisión de idoneidad del usuario principal en",
    "primaryUserCreatedAt": "Usuario principal creado el",
    "primaryUserUpdatedAt": "Usuario principal actualizado el",
    "primaryUserCompletedAt": "Usuario principal completado a las",
    "primaryUserMarketValueCents": "Valor de mercado del usuario principal (centavos)",
    "primaryUserAnnualIncomeCents": "Ingresos anuales del usuario principal (centavos)",
    "primaryUserFinancialFixedAssetsCents": "Activos fijos del usuario principal (centavos)",
    "primaryUserFinancialLiquidAssetsCents": "Activos líquidos principales (centavos)",
    "primaryUserTotalDebtCents": "Deuda total del usuario principal (centavos)",
    "primaryUserTotalNetWorthCents": "Patrimonio neto total del usuario principal (centavos)",
    "primaryUserMoneyAvailableCents": "Efectivo disponible para el usuario principal (centavos)",
    "primaryUserNetContributionCents": "Contribuciones netas del usuario principal (centavos)",
    "primaryUserNewContributionCents": "Contribuciones nuevas del usuario principal (centavos)",
    "primaryUserPendingContributionCents": "Contribuciones pendientes del usuario principal (centavos)",
    "primaryUserCashOnHoldToTradeCents": "Efectivo en espera para operaciones del usuario principal (centavos)",
    "primaryUserCashOnHoldToWithdrawCents": "Efectivo en espera para retirar del usuario principal (centavos)",
    "primaryUserMarketValue": "Valor de mercado del usuario principal",
    "primaryUserAnnualIncome": "Ingresos anuales del usuario principal",
    "primaryUserFinancialFixedAssets": "Activos fijos del usuario principal",
    "primaryUserFinancialLiquidAssets": "Activos líquidos del usuario principal",
    "primaryUserTotalDebt": "Deuda total del usuario principal",
    "primaryUserTotalNetWorth": "Patrimonio neto total del usuario principal",
    "primaryUserMoneyAvailable": "Efectivo disponible del usuario principal",
    "primaryUserNetContribution": "Contribuciones netas del usuario principal",
    "primaryUserPendingContribution": "Contribuciones pendientes del usuario principal",
    "primaryUserCashOnHoldToTrade": "Efectivo en espera para operaciones del usuario principal",
    "primaryUserCashOnHoldToWithdraw": "Efectivo en espera para retirar del usuario principal",
    "primaryUserNewContribution": "Nuevas contribuciones del usuario principal",
    "primaryUserEntityName": "Nombre de la entidad del usuario principal",
    "userFirstName": "Nombre del cliente",
    "userMiddleName": "Segundo nombre del cliente",
    "userLastName": "Apellido del cliente",
    "userState": "Estado del cliente",
    "userPrimaryEmail": "Correo electrónico del cliente",
    "userPhone": "Teléfono del cliente",
    "userStreetAddress": "Dirección postal del cliente",
    "userProvince": "Provincia del cliente",
    "userCity": "Ciudad del cliente",
    "userDateOfBirth": "Fecha de nacimiento del cliente",
    "userCompanyType": "Tipo de empresa del cliente",
    "userJobTitle": "Cargo del cliente",
    "userStudentAreaOfStudy": "Área de estudio del cliente",
    "userInvestmentKnowledge": "Conocimientos sobre inversiones del cliente",
    "userEmploymentStatus": "Situación laboral del cliente",
    "userComplianceState": "Estado de cumplimiento del cliente",
    "userSuitabilityScore": "Puntuación de idoneidad del cliente",
    "userLanguage": "Idioma del cliente",
    "userTimezone": "Zona horaria del cliente",
    "userMaritalStatus": "Estado civil del cliente",
    "userRiskQuestion1": "Pregunta sobre el riesgo del cliente primero",
    "userRiskQuestion2": "Pregunta sobre el riesgo segundo del cliente",
    "userComplianceIssueSource": "Origen del problema de cumplimiento del cliente",
    "userPoliticallyExposedDomesticPerson": "Persona políticamente expuesta nacional del cliente",
    "userPoliticallyExposedForeignPerson": "Persona políticamente expuesta extranjera del cliente",
    "userHeadOfInternationalOrganization": "Jefe de organización internacional del cliente",
    "userIDCheckCompleted": "Verificación de ID del cliente completada",
    "userLastSuitabilityReviewAt": "Última revisión de idoneidad del cliente en",
    "userCreatedAt": "Cliente creado el",
    "userUpdatedAt": "Cliente actualizado el",
    "userCompletedAt": "Cliente completado el",
    "userMarketValueCents": "Valor de mercado del cliente (centavos)",
    "userAnnualIncomeCents": "Ingresos anuales del cliente (centavos)",
    "userFinancialFixedAssetsCents": "Activos fijos del cliente (centavos)",
    "userFinancialLiquidAssetsCents": "Activos líquidos del cliente (centavos)",
    "userTotalDebtCents": "Deuda total del cliente (centavos)",
    "userTotalNetWorthCents": "Patrimonio neto total del cliente (centavos)",
    "userMoneyAvailableCents": "Efectivo disponible del cliente (centavos)",
    "userNetContributionCents": "Contribuciones netas del cliente (centavos)",
    "userNewContributionCents": "Nuevas contribuciones del cliente (centavos)",
    "userPendingContributionCents": "Contribuciones pendientes del cliente (centavos)",
    "userCashOnHoldToTradeCents": "Efectivo del cliente en espera para operaciones (centavos)",
    "userCashOnHoldToWithdrawCents": "Efectivo del cliente en espera para retirar (centavos)",
    "userMarketValue": "Valor de mercado del cliente",
    "userAnnualIncome": "Ingresos anuales del cliente",
    "userFinancialFixedAssets": "Activos fijos del cliente",
    "userFinancialLiquidAssets": "Activos líquidos del cliente",
    "userTotalDebt": "Deuda total del cliente",
    "userTotalNetWorth": "Patrimonio neto total del cliente",
    "userMoneyAvailable": "Efectivo disponible del cliente",
    "userNetContribution": "Contribuciones netas del cliente",
    "userPendingContribution": "Contribuciones pendientes del cliente",
    "userCashOnHoldToTrade": "Efectivo del cliente en espera para operaciones",
    "userCashOnHoldToWithdraw": "Efectivo del cliente en espera para retirar",
    "userNewContribution": "Nuevas contribuciones del cliente",
    "userEntityName": "Nombre de la entidad del cliente",
    "accountMarketValueCents": "Valor de mercado de la cuenta (centavos)",
    "accountMoneyAvailableCents": "Efectivo disponible en cuenta (centavos)",
    "accountNetContributionCents": "Contribuciones netas a la cuenta (centavos)",
    "accountNewContributionCents": "Contribuciones nuevas a la cuenta (centavos)",
    "accountPendingContributionCents": "Contribuciones pendientes de la cuenta (centavos)",
    "accountCashOnHoldToTradeCents": "Efectivo en espera para operaciones de la cuenta (centavos)",
    "accountCashOnHoldToWithdrawCents": "Efectivo en espera para retirar de la cuenta (centavos)",
    "accountMarketValue": "Valor de mercado de la cuenta",
    "accountMoneyAvailable": "Efectivo disponible en cuenta",
    "accountNetContribution": "Contribuciones netas a la cuenta",
    "accountPendingContribution": "Contribuciones pendientes de la cuenta",
    "accountCashOnHoldToTrade": "Efectivo en espera para operaciones de la cuenta",
    "accountCashOnHoldToWithdraw": "Efectivo en espera para retirar de la cuenta",
    "accountNewContribution": "Contribuciones nuevas de la cuenta",
    "subAccountMoneyAvailableCents": "Efectivo disponible en subcuenta (centavos)",
    "subAccountNetContributionCents": "Contribuciones netas de la subcuenta (centavos)",
    "subAccountNewContributionCents": "Contribuciones nuevas de la subcuenta (centavos)",
    "subAccountPendingContributionCents": "Contribuciones pendientes de la subcuenta (centavos)",
    "subAccountCashOnHoldToTradeCents": "Efectivo en espera para operaciones de la subcuenta (centavos)",
    "subAccountCashOnHoldToWithdrawCents": "Efectivo en espera para retirar de la subcuenta (centavos)",
    "subAccountMarketValue": "Valor de mercado de la subcuenta",
    "subAccountMoneyAvailable": "Efectivo disponible en subcuenta",
    "subAccountNetContribution": "Contribuciones netas de la subcuenta",
    "subAccountPendingContribution": "Contribuciones pendientes de la subcuenta",
    "subAccountCashOnHoldToTrade": "Efectivo en espera para operaciones de la subcuenta",
    "subAccountCashOnHoldToWithdraw": "Efectivo en espera para retirar de la subcuenta",
    "subAccountNewContribution": "Nuevas contribuciones de la subcuenta",
    "organization": "Organización",
    "deactivatedAt": "Desactivado en",
    "frozenAt": "Congelado en",
    "reviewingAt": "Revisando en",
    "readyAt": "Listo en",
    "requestedAt": "Solicitado en",
    "processingAt": "Procesando en",
    "failedAt": "Falló en",
    "canceledAt": "Cancelado en",
    "activatedAt": "Activado en",
    "allSigned": "Todos los documentos firmados",
    "isOfficerOfPublicCompany": "Es funcionario de una empresa pública",
    "isOwnerOfPublicCompany": "Es propietario de una empresa pública",
    "isMemberOfIiroc": "Es miembro de Iiroc",
    "politicallyExposedForeignPerson": "Persona extranjera políticamente expuesta",
    "politicallyExposedDomesticPerson": "Persona políticamente expuesta a nivel nacional",
    "closeAssociateOfPEP": "Asociado cercano de PEP",
    "powerOfAttorneyGranted": "Poder notarial otorgado",
    "headOfInternationalOrganization": "Jefe de Organización Internacional",
    "isSuspicious": "Es sospechoso",
    "suspiciousRules": "Reglas sospechosas",
    "suspiciousState": "Estado sospechoso",
    "settleDate": "Fecha de liquidación",
    "date": "Fecha",
    "quantity": "Cantidad",
    "subAccountFinancialProductName": "Nombre de la cartera modelo de subcuenta",
    "valueCents": "Valor en centavos",
    "goalId": "ID de meta",
    "goalName": "Nombre de meta",
    "goalType": "Tipo de meta",
    "goalTimeHorizon": "Horizonte temporal de la meta",
    "goalTargetAmountCents": "Cantidad de importe de objetivo en centavos",
    "feeTierId": "Identificación del nivel de tarifa",
    "feeTierName": "Nombre del nivel de tarifa",
    "feeTierState": "Nivel de tarifa estatal",
    "clientGroupId": "ID del grupo de cliente",
    "clientGroupName": "Nombre del grupo de cliente",
    "clientGroupType": "Tipo de grupo de cliente",
    "clientGroupState": "Estado del grupo de cliente",
    "clientGroupPrimaryUserId": "ID de usuario principal del grupo de cliente",
    "clientGroupFeeTierId": "Identificación del nivel de tarifas del grupo de cliente",
    "clientGroupFeeTierState": "Estado del nivel de tarifas del grupo de cliente",
    "clientGroupFeeTierName": "Nombre del nivel de tarifas del grupo de cliente",
    "affiliateOnly": "Solo para afiliados",
    "currency": "Moneda",
    "moneyAllocatedCents": "Dinero asignado",
    "expectedTradePriceCents": "Precio comercial previsto",
    "actualQuantity": "Cantidad actual",
    "expectedQuantity": "Cantidad prevista",
    "actualTradePriceCents": "Precio comercial real",
    "percentageFilled": "Porcentaje completado",
    "timeHorizon": "Horizonte temporal",
    "tradeSecurity": "Seguridad comercial",
    "moneyAllocated": "Dinero asignado",
    "expectedTradePrice": "Precio comercial previsto",
    "actualTradePrice": "Precio comercial real",
    "uniqueCircumstances": "Circunstancias únicas",
    "sourceOfWealth": "Origen de la riqueza",
    "sourceOfWealthOtherDescription": "Descripción de la fuente de riqueza",
    "sourceOfFunds": "Origen de los fondos",
    "sourceOfFundsOtherDescription": "Descripción del origen de los fondos",
    "preferredMethodOfCommunication": "Método de comunicación preferido:",
    "preferredMethodOfCommunicationOtherDescription": "Descripción del método de comunicación preferido",
    "employerName": "Nombre del empleador",
    "payTaxesOutsideCanada": "Pagar impuestos fuera de Canadá",
    "trustedContactPersonName": "Nombre del contacto de confianza",
    "trustedContactPersonEmail": "Correo electrónico del contacto de confianza",
    "trustedContactPersonPhone": "Teléfono del contacto de confianza",
    "trustedContactPersonCity": "Ciudad del contacto de confianza",
    "trustedContactPersonProvince": "Provincia del contacto de confianza",
    "trustedContactPersonRelation": "Relación del contacto de confianza",
    "spouseFirstName": "Nombre del cónyuge",
    "spouseLastName": "Apellido del cónyuge",
    "spouseEmail": "Correo electrónico del cónyuge",
    "spouseEmploymentType": "Tipo de empleo del cónyuge",
    "spouseCompanyType": "Tipo de empresa del cónyuge",
    "spouseJobTitle": "Ocupación del cónyuge",
    "spouseDateOfBirth": "Fecha de nacimiento del cónyuge",
    "spouseAddressProvince": "Provincia del cónyuge",
    "spouseAddressCity": "Ciudad del cónyuge",
    "employerCompanyAddress": "Dirección de la empresa empleadora",
    "numberOfClients": "# de clientes",
    "numberOfFundedClients": "# de clientes financiados",
    "calculatedAt": "Calculado en",
    "isAccreditedInvestor": "Es inversor acreditado",
    "isVulnerablePerson": "Es una persona vulnerable",
    "iDVerified": "ID verificada",
    "entityName": "Nombre de la entidad",
    "exchange": "Intercambio",
    "ticker": "Ticker",
    "scheduleNextDate": "Programar próxima fecha",
    "actualTradePriceInCurrencyCents": "Precio real de negociación en centavos de moneda",
    "preSplitMaxQuantity": "Cantidad máxima antes de la división",
    "blockedUntil": "Bloqueado hasta",
    "blockedUntilSubAccountActive": "Bloqueado hasta que la subcuenta esté activa",
    "blockedUntilAccountActive": "Bloqueado hasta que la cuenta esté activa",
    "blockedUntilPairActualTradePriceCents": "Bloquear hasta que coincida el precio real de negociación (en centavos)",
    "maxQuantity": "Cantidad máxima",
    "publishedAt": "Publicado en",
    "isSuggestedByOptimizer": "Es sugerido por Optimizer",
    "verificationRequired": "Se requiere verificación",
    "isPartial": "Es parcial",
    "isSellAll": "Es vender todo",
    "originalCurrency": "Moneda original",
    "preSplitMoneyAllocated": "Dinero asignado antes de la división",
    "settlementDays": "Días de liquidación",
    "settlementDate": "Fecha de liquidación",
    "volatile": "Volátil",
    "verifiedByUser": "Verificado por el usuario",
    "verifiedAt": "Verificado en",
    "initiatedAt": "Iniciado en",
    "accountBaseCurrency": "Moneda base de la cuenta",
    "organizationBaseCurrency": "Moneda base de la organización",
    "moneyAvailableInOrgCurrency": "Efectivo disponible en la moneda de la organización",
    "netContributionInOrgCurrency": "Contribuciones netas en la moneda de la organización",
    "newContributionInOrgCurrency": "Nuevas contribuciones en moneda de la organización",
    "pendingContributionInOrgCurrency": "Contribuciones pendientes en la moneda de la organización",
    "cashOnHoldToTradeInOrgCurrency": "Efectivo en espera para operaciones en la moneda de la organización",
    "cashOnHoldToWithdrawInOrgCurrency": "Efectivo en espera para retirar en la moneda de la organización",
    "marketValueInOrgCurrency": "Valor de mercado en la moneda de la organización",
    "moneyAvailableCentsInOrgCurrency": "Efectivo disponible en la moneda de la organización (centavos)",
    "netContributionCentsInOrgCurrency": "Contribuciones netas en la moneda de la organización (centavos)",
    "newContributionCentsInOrgCurrency": "Nuevas contribuciones en moneda de la organización (centavos)",
    "pendingContributionCentsInOrgCurrency": "Contribuciones pendientes en la moneda de la organización (centavos)",
    "cashOnHoldToTradeCentsInOrgCurrency": "Efectivo en espera para operaciones en la moneda de la organización (centavos)",
    "cashOnHoldToWithdrawCentsInOrgCurrency": "Efectivo en espera para retirar en la moneda de la organización (centavos)",
    "marketValueCentsInOrgCurrency": "Valor de mercado en la moneda de la organización (centavos)",
    "fraudRisk": "Riesgo de fraude",
    "tradingProcess": "Proceso de operación",
    "fatcaStatus": "Estado FATCA",
    "userAccountGroupId": "ID del grupo de cuentas de usuario",
    "householdAccountGroupId": "ID del grupo de cuentas domésticas",
    "organizationAccountGroupId": "ID del grupo de cuentas de la organización",
    "accountRepCode": "Código de Representante de Cuenta",
    "accountRepCodes": "Códigos de Representante de Cuenta",
    "repCode": "Código de Representante"
  },
  "chartType": "Tipo de gráfico",
  "groupOn": "Agrupar en",
  "title": "Título",
  "valueAggregation": "Agregación",
  "formatTitle": "Formato",
  "valueFieldTitle": "Campo de valor",
  "groupingType": "Tipo de agrupación",
  "interval": "Intervalo",
  "reportType": "Tipo de informe",
  "addWidget": "Añadir widget",
  "successSaveDashboard": "Panel de control guardado correctamente",
  "inheritedDashboardReadOnly": "Este panel pertenece a una organización principal. No se puede guardar el diseño ni los widgets desde esta organización.",
  "addModal": {
    "title": "Nuevo panel de control",
    "name": "Nombre",
    "organization": "Organización"
  },
  "chartTypes": {
    "BAR": "Gráfico de barras",
    "LINE": "Gráfico de líneas",
    "NUMBER": "Valor numérico",
    "PIE": "Gráfico circular"
  },
  "aggregationTypes": {
    "AVG": "Promedio",
    "SUM": "Suma",
    "VALUE_COUNT": "Contar"
  },
  "valueField": {
    "id": "ID",
    "marketValueCents": "Valor de mercado",
    "amountCents": "Importe",
    "valueCents": "Valor"
  },
  "format": {
    "CENTS": "Dólar",
    "FLOAT": "Número"
  },
  "groupingTypes": {
    "DATE": "Fecha",
    "FIRST_DATE_IN_INTERVAL": "Primero en intervalo",
    "GROUPING": "Grupo",
    "SINGLE_VALUE": "Valor único"
  },
  "intervals": {
    "DAY": "Día",
    "MONTH": "Mes",
    "WEEK": "Semana",
    "YEAR": "Año"
  },
  "reportTypes": {
    "ACCOUNT": "Cuenta",
    "DAILY_STATS": "Estadísticas diarias",
    "HISTORY": "Historial",
    "SUB_ACCOUNT": "Subcuentas",
    "TRANSFER": "Transferencias",
    "USER": "Usuario",
    "TRANSACTION": "Transacción",
    "GOAL": "Meta",
    "CLIENT_GROUP": "Hogares",
    "TRADE": "Transacción",
    "SUB_TRADE_REQUEST": "Solicitud de suboperación"
  },
  "comparisons": {
    "TEXT_SEARCH": "buscar",
    "EQUALS": "es igual a",
    "NOT_EQUALS": "no es igual a",
    "INCLUDES": "incluye",
    "NOT_INCLUDES": "no incluye",
    "GREATER_THAN": "mayor que",
    "LESS_THAN": "menor que",
    "GREATER_THAN_AGO": "hace más de",
    "LESS_THAN_AGO": "hace menos de",
    "IN": "en",
    "NOT_TEXT_SEARCH": "no busca"
  },
  "globalFilters": {
    "ruleChip": "{{type}} {{field}} {{comparison}} {{value}}",
    "label": "Filtros globales",
    "addRule": "Añadir regla global",
    "clearRules": "Borrar reglas activas ({{count}})",
    "editTitle": "Editar filtros globales",
    "appliesToWidgets": "Se aplica a {{count}} widgets de este tipo",
    "appliesToNoWidgets": "No hay widgets de este tipo en este panel de control",
    "widgetBadge": "Filtrado",
    "appliedToWidget": "{{count}} filtros globales aplicados"
  },
  "widgetError": "No se puede mostrar este widget",
  "widgetOptionsError": "No se pueden cargar las opciones del informe. Cierre e intente de nuevo.",
  "successRenameDashboard": "Panel de control renombrado correctamente",
  "unsavedTitle": "¿Descartar cambios no guardados?",
  "unsavedBody": "Tiene cambios sin guardar en este panel de control. Si sale ahora, esos cambios se perderán.",
  "discardChanges": "Descartar",
  "untitledDashboard": "Panel de control",
  "renameModal": {
    "title": "Renombrar panel de control",
    "name": "Nombre"
  },
  "a11y": {
    "moreActions": "Más acciones"
  },
  "dashboardMenu": {
    "rename": "Renombrar",
    "copyFrom": "Copiar de otro panel de control"
  },
  "addWidgetPlaceholder": {
    "title": "Añadir widget"
  },
  "copyFrom": {
    "title": "Copiar de otro panel de control",
    "source": "Panel de control a copiar",
    "noSources": "No hay otros paneles de control de los que copiar.",
    "truncated": "Mostrando los primeros {{shown}} paneles de control.",
    "summary": "Copia {{widgetCount}} widgets ({{reportTypes}}) y cualquier filtro global.",
    "emptySource": "Ese panel de control no tiene widgets para copiar.",
    "replaceWarning": "Esto reemplaza los {{widgetCount}} widgets y {{filterCount}} filtros globales que ya están en este panel de control.",
    "unsavedHint": "Nada se guarda hasta que guarde el panel de control.",
    "confirm": "Reemplazar widgets",
    "success": "Widgets copiados. Guarde el panel de control para conservarlos."
  }
}
